// extracted by mini-css-extract-plugin
export default {"addIcon":"iconMapper_addIcon__31ma7","ellipsisIcon":"iconMapper_ellipsisIcon__TjQJ1","openInDesktopIcon":"iconMapper_openInDesktopIcon__8dbUB"};